import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';
import { createCianAnalyticsPageWithExtra } from 'shared/utils/createCianAnalyticsPageWithExtra';

interface IParameters {
  query: string;
  deviceType: TDeviceType;
}

export function trackSubmitClick({ query, deviceType }: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'button_search',
    label: query,
    page: createCianAnalyticsPageWithExtra({
      deviceType,
      extra: {
        source: query !== '' ? 'search_string' : '',
      },
    }),
  });
}

export function trackMapSubmitClick({ query, deviceType }: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'button_search_on_map',
    label: query,
    page: createCianAnalyticsPageWithExtra({
      deviceType,
      extra: {
        source: query !== '' ? 'search_string' : '',
      },
    }),
  });
}
